export const gitVersion = 'main-1.0.13-521-g53135caa';
